module.exports = __webpack_public_path__ + "img/common-file-lock.6071c43a.svg";